import { createRoutePoint } from '../../utils';
import { mapActions } from '../reducer';

export const resetRoutePoints = () => mapActions.setRoutePoints([
  createRoutePoint(),
  createRoutePoint()
]);
